module.exports = __webpack_public_path__ + "img/relieved-face.22d92baa.png";